<template minapp='mpx' xlang='wxml'>
  <view wx:if="{{number}}" class="wrapper">
    <view class="offline-refund">
      <view class="offline-refund-text">
        <view class="offline-refund-text-num">温馨提示：</view>
        当前订单{{number}}笔线下退款，需尽快确认</view
      >
      <view bindtap="toOfflineRefundDetailPage" class="offline-refund-arrow"
        >退款确认<image class="icon" src="https://ut-static.udache.com/webx/sfc/SurrbhwdBTSNdfKCJ6aCW.png"/>
      </view>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'
import { innerRouter, pagePath } from '@/common/jump'

createComponent({
  props: {
    number: Number,
    orderId: String
  },
  methods: {
    toOfflineRefundDetailPage() {
      const { from = '' } = this.$mpxRoute.query
      innerRouter.push(pagePath().REFUNDOFFLINE, {
        from,
        order_id: this.orderId
      })
    }
  }
})
</script>
<style scoped lang="stylus">
@import '~@/mixins/stylus/color.styl'

.wrapper
  margin 0 -12px
  background-color #fff
  padding 12px
  padding-top 0
.offline-refund
  display flex
  align-items center
  justify-content space-between
  border-radius 6px
  box-sizing border-box
  padding 10px
  font-size 12px
  font-family PingFangSC-Medium;
  background-color #FFF0EE
  &-icon
    width 20px
    height 20px
    margin-right 4px
    background-repeat no-repeat
    background-size 100%
    background-position center
    background-image url('https://img-hxy021.didistatic.com/static/starimg/img/XApIU4jPEH1686801129710.png')
  &-text
    display flex
    align-items center
    flex 1
    color #3D3D3D
    font-family PingFangSC-Medium
    &-num
      color #FF4129
  &-arrow
    height 100%
    font-family PingFangSC-Medium
    flex none
    display flex
    color #FF4129
    align-items center
	.icon 
	  height 12px
	  width 12px
</style>
<script name='json'>
module.exports = {
  component: true
}
</script>